const MainImages = [
    {
        id: 1,
        imgUrl: "./main_images/main2.png"
    },
    // {
    //     id: 2,
    //     imgUrl: "./main_images/sample2.png"
    // },
    // {
    //     id: 3,
    //     imgUrl: "./main_images/sample3.png"
    // },
    {
        id: 4,
        imgUrl: "./main_images/main1.png"
    }
]

export default MainImages;